// Observe an element's size, delivering the callback on the next animation
// frame instead of inside the observer's own notification pass.
//
// Setting React state synchronously inside a ResizeObserver callback re-lays
// out the widget while the browser is still delivering that pass. When the
// re-layout changes the observed box again, Chrome drops the second pass and
// logs "ResizeObserver loop completed with undelivered notifications" — the
// CRA dev overlay turns that into a full-screen error. Deferring one frame
// breaks the cycle without losing the final size.
export function observeResize(
  el: Element,
  callback: (entries: ResizeObserverEntry[]) => void,
): () => void {
  let frame: number | null = null;
  const observer = new ResizeObserver((entries) => {
    if (frame !== null) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      callback(entries);
    });
  });
  observer.observe(el);
  return () => {
    if (frame !== null) cancelAnimationFrame(frame);
    observer.disconnect();
  };
}
